import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/payout-requests/usePayoutRequestQueryKeys.ts
var t = e("payout-requests", {
	forWorkspace: (e) => ["workspace", e],
	detail: (e) => ["detail", e],
	statement: (e) => ["statement", e],
	eligibleBookings: (e, t) => [
		"eligible-bookings",
		e,
		t
	],
	upcoming: (e) => ["upcoming", e]
});
//#endregion
export { t as payoutRequestQueryKeys };
